import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startRequest as fetchPercentDeposits } from 'modules/UserIncomes/redux/percentDeposits/actions';
import { startRequest as fetchContacts } from 'modules/Contacts/redux/contacts/actions';
import {
  percentDepositsYearsSelector,
  percentDepositsBanksGroupedByYearsSelector,
} from 'modules/UserIncomes/selectors';
import { getTaxAuthorityByRegistration } from 'modules/Contacts/selectors';
import { PercentDepositsPage } from './PercentDepositsPage';
import RelativeLoading from '../../../../components/Loading/RelativeLoading';

const PercentDepositsPageContainer = () => {
  const dispatch = useDispatch();
  const periods = useSelector(percentDepositsYearsSelector);
  const taxAuthority = useSelector(getTaxAuthorityByRegistration);
  const banks = useSelector(percentDepositsBanksGroupedByYearsSelector);

  useEffect(() => {
    dispatch(fetchPercentDeposits());
    dispatch(fetchContacts());
  }, []);

  return (
    <div className={'boo'}>
      {periods && banks && taxAuthority ? (
        <PercentDepositsPage periods={periods} banks={banks} taxAuthority={taxAuthority} />
      ) : (
        <RelativeLoading />
      )}
    </div>
  );
};

export default PercentDepositsPageContainer;
